import { useTranslation } from 'react-i18next'
import PageModal from '../../common/PageModal'
import SimpleButton from '../../common/SimpleButton'
import ToggleSwitch from '../../common/ToggleSwitch'
import { firmwareUploadWritePermission } from '../../../utils/permissionValidation'
import { getFileIcon } from '../../../utils/functions'
import '../uploads.scss'

const ViewSoftwareFileModal = (props) => {
  const { t } = useTranslation()
  const { selectedFile, handleEditFile, closeModal } = props
  const softwareFileStatuses = ['inactive', 'active']

  const softwareFileHeaderContent = () => {
    return (
      <div className="status-wrapper">
        <div className="label">{t('status')}</div>
        <ToggleSwitch checked={selectedFile.isActive} isDisabled={true} />
        <div className="status">{t(softwareFileStatuses[Number(selectedFile.isActive)])}</div>
      </div>
    )
  }

  const softwareFileFooterContent = () => {
    return (
      <>
        <SimpleButton className="cancel-button" onClick={closeModal}>
          {t('close')}
        </SimpleButton>
        <SimpleButton className="action-button" onClick={handleEditFile} requiredPermission={firmwareUploadWritePermission}>
          {t('edit')}
        </SimpleButton>
      </>
    )
  }

  return (
    <>
      <PageModal
        toggle
        onToggle={closeModal}
        className="uploads-modal"
        title={t('details')}
        headerContent={softwareFileHeaderContent()}
        footerContent={softwareFileFooterContent()}
      >
        <div className="uploads-modal-content">
          <div className="section-title">{t('general_information').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('file_name')}</p>
              <div className="value">
                {getFileIcon(selectedFile.fileName)}
                {selectedFile.fileName}
              </div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('total_downloads')}</p>
              <div className="value">{selectedFile.totalDownloads || 0}</div>
            </div>
          </div>
          <div className="separator" />
          <div className="section-title">{t('settings').toUpperCase()}</div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('firmware_context.file_display_title')}</p>
              <div className="value">{selectedFile.fileTitle}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('firmware_context.device_software_label')}</p>
              <div className="value">{selectedFile.softwareLabel}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('model')}</p>
              <div className="value">{selectedFile.models?.join(', ')}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('firmware_context.firmware_type')}</p>
              <div className="value">{selectedFile.firmwareType}</div>
            </div>
          </div>
          <div className="row-wrapper">
            <div className="input-wrapper">
              <p className="input-option">{t('prefix')}</p>
              <div className="value">{selectedFile.prefix}</div>
            </div>
            <div className="input-wrapper">
              <p className="input-option">{t('document_context.revision_number')}</p>
              <div className="value">{selectedFile.prefixNumber}</div>
            </div>
          </div>
        </div>
      </PageModal>
    </>
  )
}

export default ViewSoftwareFileModal

